module.exports = __webpack_public_path__ + "static/arvsfonden-277327a2f9b06680d833c503dce31b3a.png";